import { formatDate } from '@angular/common';
import moment from 'moment';
import { Price } from './models/price';
import { GraphQLError } from 'graphql';
import { ClientError } from './models/client-error';

export default class Utils {
  static sum(array: number[]): number {
    return array.reduce((a, b) => a + b, 0);
  }

  static valueTotal(qty: number, price: Price): number {
    return (qty * price.amount) / price.unit;
  }

  static utcDate(date: string): Date {
    return !date ? null : new Date(formatDate(date, 'shortDate', 'en-US', 'UTC'));
  }

  static combineWithUppercase(val: string): string {
    return val.replace(/\s+/g, '-').toUpperCase();
  }

  static dateString(date: Date): string {
    // the server expects ISO 8601
    // we are not including the time due to datetime offset issues
    return date ? moment(date).format().substring(0, 10) + 'T00:00:00.000+00' : null;
  }
  // Using the local date can create problems when it is behind the UTC date, so we need the max of the local date and the UTC date
  static today(): Date {
    const localDate = new Date();
    const utcDate = new Date(formatDate(localDate, 'shortDate', 'en-US', 'UTC'));
    return localDate > utcDate ? localDate : utcDate;
  }

  static extractClientError(errors: GraphQLError[]): ClientError {
    if (!errors && !errors.length) {
      return null;
    }
    const [error] = errors;
    return <ClientError>({
      code: error.extensions ? (error.extensions.code || null) : null,
      message: error.message,
      errData: error.extensions ? (error.extensions.data || null) : null
    });
  }
}
